export default __webpack_public_path__ + "static/Ogg-Light-a845a5089dc15034586cfcf1502b877d.ttf";